//TODO : Refactor after ai
import i18next, { type Resource } from "i18next";
import { initReactI18next } from "react-i18next";
import EnJson from "./jsons/en.json";
import DeJson from "./jsons/de.json";
import ArJson from "./jsons/ar.json";
import type { LanguageTypes } from "./types";

const resources: Resource = {
  en: {
    translation: EnJson,
  },
  de: {
    translation: DeJson,
  },
  ar: {
    translation: ArJson,
  },
};

const VALID_LANGUAGES: LanguageTypes[] = ["en", "de", "ar"];
// Reading storage can throw in a sandboxed (opaque-origin) iframe; the
// language is a preference, so fall back to the default instead of crashing.
let stored: LanguageTypes | null = null;
try {
  stored = localStorage.getItem("lng") as LanguageTypes | null;
} catch {
  stored = null;
}
const initialLanguage: LanguageTypes =
  stored && VALID_LANGUAGES.includes(stored) ? stored : "de";

i18next.use(initReactI18next).init({
  lng: initialLanguage,
  fallbackLng: "en",
  resources,
  interpolation: {
    escapeValue: false,
  },
  react: { useSuspense: false },
});

export default i18next;
